module.exports = __webpack_public_path__ + "img/design.a5609fc1.svg";